!(function () {
  var t = {
      633: function (t, e, r) {
        var n = r(738).default;
        function o() {
          "use strict";
          ((t.exports = o =
            function () {
              return r;
            }),
            (t.exports.__esModule = !0),
            (t.exports.default = t.exports));
          var e,
            r = {},
            i = Object.prototype,
            a = i.hasOwnProperty,
            c =
              Object.defineProperty ||
              function (t, e, r) {
                t[e] = r.value;
              },
            u = "function" == typeof Symbol ? Symbol : {},
            s = u.iterator || "@@iterator",
            l = u.asyncIterator || "@@asyncIterator",
            f = u.toStringTag || "@@toStringTag";
          function p(t, e, r) {
            return (
              Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              }),
              t[e]
            );
          }
          try {
            p({}, "");
          } catch (e) {
            p = function (t, e, r) {
              return (t[e] = r);
            };
          }
          function h(t, e, r, n) {
            var o = e && e.prototype instanceof w ? e : w,
              i = Object.create(o.prototype),
              a = new N(n || []);
            return (c(i, "_invoke", { value: P(t, r, a) }), i);
          }
          function d(t, e, r) {
            try {
              return { type: "normal", arg: t.call(e, r) };
            } catch (t) {
              return { type: "throw", arg: t };
            }
          }
          r.wrap = h;
          var y = "suspendedStart",
            v = "suspendedYield",
            m = "executing",
            g = "completed",
            b = {};
          function w() {}
          function x() {}
          function L() {}
          var _ = {};
          p(_, s, function () {
            return this;
          });
          var E = Object.getPrototypeOf,
            S = E && E(E(G([])));
          S && S !== i && a.call(S, s) && (_ = S);
          var k = (L.prototype = w.prototype = Object.create(_));
          function j(t) {
            ["next", "throw", "return"].forEach(function (e) {
              p(t, e, function (t) {
                return this._invoke(e, t);
              });
            });
          }
          function O(t, e) {
            function r(o, i, c, u) {
              var s = d(t[o], t, i);
              if ("throw" !== s.type) {
                var l = s.arg,
                  f = l.value;
                return f && "object" == n(f) && a.call(f, "__await")
                  ? e.resolve(f.__await).then(
                      function (t) {
                        r("next", t, c, u);
                      },
                      function (t) {
                        r("throw", t, c, u);
                      },
                    )
                  : e.resolve(f).then(
                      function (t) {
                        ((l.value = t), c(l));
                      },
                      function (t) {
                        return r("throw", t, c, u);
                      },
                    );
              }
              u(s.arg);
            }
            var o;
            c(this, "_invoke", {
              value: function (t, n) {
                function i() {
                  return new e(function (e, o) {
                    r(t, n, e, o);
                  });
                }
                return (o = o ? o.then(i, i) : i());
              },
            });
          }
          function P(t, r, n) {
            var o = y;
            return function (i, a) {
              if (o === m) throw Error("Generator is already running");
              if (o === g) {
                if ("throw" === i) throw a;
                return { value: e, done: !0 };
              }
              for (n.method = i, n.arg = a; ; ) {
                var c = n.delegate;
                if (c) {
                  var u = q(c, n);
                  if (u) {
                    if (u === b) continue;
                    return u;
                  }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                  if (o === y) throw ((o = g), n.arg);
                  n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = m;
                var s = d(t, r, n);
                if ("normal" === s.type) {
                  if (((o = n.done ? g : v), s.arg === b)) continue;
                  return { value: s.arg, done: n.done };
                }
                "throw" === s.type &&
                  ((o = g), (n.method = "throw"), (n.arg = s.arg));
              }
            };
          }
          function q(t, r) {
            var n = r.method,
              o = t.iterator[n];
            if (o === e)
              return (
                (r.delegate = null),
                ("throw" === n &&
                  t.iterator.return &&
                  ((r.method = "return"),
                  (r.arg = e),
                  q(t, r),
                  "throw" === r.method)) ||
                  ("return" !== n &&
                    ((r.method = "throw"),
                    (r.arg = new TypeError(
                      "The iterator does not provide a '" + n + "' method",
                    )))),
                b
              );
            var i = d(o, t.iterator, r.arg);
            if ("throw" === i.type)
              return (
                (r.method = "throw"),
                (r.arg = i.arg),
                (r.delegate = null),
                b
              );
            var a = i.arg;
            return a
              ? a.done
                ? ((r[t.resultName] = a.value),
                  (r.next = t.nextLoc),
                  "return" !== r.method && ((r.method = "next"), (r.arg = e)),
                  (r.delegate = null),
                  b)
                : a
              : ((r.method = "throw"),
                (r.arg = new TypeError("iterator result is not an object")),
                (r.delegate = null),
                b);
          }
          function T(t) {
            var e = { tryLoc: t[0] };
            (1 in t && (e.catchLoc = t[1]),
              2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
              this.tryEntries.push(e));
          }
          function F(t) {
            var e = t.completion || {};
            ((e.type = "normal"), delete e.arg, (t.completion = e));
          }
          function N(t) {
            ((this.tryEntries = [{ tryLoc: "root" }]),
              t.forEach(T, this),
              this.reset(!0));
          }
          function G(t) {
            if (t || "" === t) {
              var r = t[s];
              if (r) return r.call(t);
              if ("function" == typeof t.next) return t;
              if (!isNaN(t.length)) {
                var o = -1,
                  i = function r() {
                    for (; ++o < t.length; )
                      if (a.call(t, o))
                        return ((r.value = t[o]), (r.done = !1), r);
                    return ((r.value = e), (r.done = !0), r);
                  };
                return (i.next = i);
              }
            }
            throw new TypeError(n(t) + " is not iterable");
          }
          return (
            (x.prototype = L),
            c(k, "constructor", { value: L, configurable: !0 }),
            c(L, "constructor", { value: x, configurable: !0 }),
            (x.displayName = p(L, f, "GeneratorFunction")),
            (r.isGeneratorFunction = function (t) {
              var e = "function" == typeof t && t.constructor;
              return (
                !!e &&
                (e === x || "GeneratorFunction" === (e.displayName || e.name))
              );
            }),
            (r.mark = function (t) {
              return (
                Object.setPrototypeOf
                  ? Object.setPrototypeOf(t, L)
                  : ((t.__proto__ = L), p(t, f, "GeneratorFunction")),
                (t.prototype = Object.create(k)),
                t
              );
            }),
            (r.awrap = function (t) {
              return { __await: t };
            }),
            j(O.prototype),
            p(O.prototype, l, function () {
              return this;
            }),
            (r.AsyncIterator = O),
            (r.async = function (t, e, n, o, i) {
              void 0 === i && (i = Promise);
              var a = new O(h(t, e, n, o), i);
              return r.isGeneratorFunction(e)
                ? a
                : a.next().then(function (t) {
                    return t.done ? t.value : a.next();
                  });
            }),
            j(k),
            p(k, f, "Generator"),
            p(k, s, function () {
              return this;
            }),
            p(k, "toString", function () {
              return "[object Generator]";
            }),
            (r.keys = function (t) {
              var e = Object(t),
                r = [];
              for (var n in e) r.push(n);
              return (
                r.reverse(),
                function t() {
                  for (; r.length; ) {
                    var n = r.pop();
                    if (n in e) return ((t.value = n), (t.done = !1), t);
                  }
                  return ((t.done = !0), t);
                }
              );
            }),
            (r.values = G),
            (N.prototype = {
              constructor: N,
              reset: function (t) {
                if (
                  ((this.prev = 0),
                  (this.next = 0),
                  (this.sent = this._sent = e),
                  (this.done = !1),
                  (this.delegate = null),
                  (this.method = "next"),
                  (this.arg = e),
                  this.tryEntries.forEach(F),
                  !t)
                )
                  for (var r in this)
                    "t" === r.charAt(0) &&
                      a.call(this, r) &&
                      !isNaN(+r.slice(1)) &&
                      (this[r] = e);
              },
              stop: function () {
                this.done = !0;
                var t = this.tryEntries[0].completion;
                if ("throw" === t.type) throw t.arg;
                return this.rval;
              },
              dispatchException: function (t) {
                if (this.done) throw t;
                var r = this;
                function n(n, o) {
                  return (
                    (c.type = "throw"),
                    (c.arg = t),
                    (r.next = n),
                    o && ((r.method = "next"), (r.arg = e)),
                    !!o
                  );
                }
                for (var o = this.tryEntries.length - 1; o >= 0; --o) {
                  var i = this.tryEntries[o],
                    c = i.completion;
                  if ("root" === i.tryLoc) return n("end");
                  if (i.tryLoc <= this.prev) {
                    var u = a.call(i, "catchLoc"),
                      s = a.call(i, "finallyLoc");
                    if (u && s) {
                      if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                      if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                    } else if (u) {
                      if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                    } else {
                      if (!s)
                        throw Error("try statement without catch or finally");
                      if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                    }
                  }
                }
              },
              abrupt: function (t, e) {
                for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                  var n = this.tryEntries[r];
                  if (
                    n.tryLoc <= this.prev &&
                    a.call(n, "finallyLoc") &&
                    this.prev < n.finallyLoc
                  ) {
                    var o = n;
                    break;
                  }
                }
                o &&
                  ("break" === t || "continue" === t) &&
                  o.tryLoc <= e &&
                  e <= o.finallyLoc &&
                  (o = null);
                var i = o ? o.completion : {};
                return (
                  (i.type = t),
                  (i.arg = e),
                  o
                    ? ((this.method = "next"), (this.next = o.finallyLoc), b)
                    : this.complete(i)
                );
              },
              complete: function (t, e) {
                if ("throw" === t.type) throw t.arg;
                return (
                  "break" === t.type || "continue" === t.type
                    ? (this.next = t.arg)
                    : "return" === t.type
                      ? ((this.rval = this.arg = t.arg),
                        (this.method = "return"),
                        (this.next = "end"))
                      : "normal" === t.type && e && (this.next = e),
                  b
                );
              },
              finish: function (t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var r = this.tryEntries[e];
                  if (r.finallyLoc === t)
                    return (this.complete(r.completion, r.afterLoc), F(r), b);
                }
              },
              catch: function (t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var r = this.tryEntries[e];
                  if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                      var o = n.arg;
                      F(r);
                    }
                    return o;
                  }
                }
                throw Error("illegal catch attempt");
              },
              delegateYield: function (t, r, n) {
                return (
                  (this.delegate = {
                    iterator: G(t),
                    resultName: r,
                    nextLoc: n,
                  }),
                  "next" === this.method && (this.arg = e),
                  b
                );
              },
            }),
            r
          );
        }
        ((t.exports = o),
          (t.exports.__esModule = !0),
          (t.exports.default = t.exports));
      },
      738: function (t) {
        function e(r) {
          return (
            (t.exports = e =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (t) {
                    return typeof t;
                  }
                : function (t) {
                    return t &&
                      "function" == typeof Symbol &&
                      t.constructor === Symbol &&
                      t !== Symbol.prototype
                      ? "symbol"
                      : typeof t;
                  }),
            (t.exports.__esModule = !0),
            (t.exports.default = t.exports),
            e(r)
          );
        }
        ((t.exports = e),
          (t.exports.__esModule = !0),
          (t.exports.default = t.exports));
      },
      756: function (t, e, r) {
        var n = r(633)();
        t.exports = n;
        try {
          regeneratorRuntime = n;
        } catch (t) {
          "object" == typeof globalThis
            ? (globalThis.regeneratorRuntime = n)
            : Function("r", "regeneratorRuntime = r")(n);
        }
      },
    },
    e = {};
  function r(n) {
    var o = e[n];
    if (void 0 !== o) return o.exports;
    var i = (e[n] = { exports: {} });
    return (t[n](i, i.exports, r), i.exports);
  }
  ((r.n = function (t) {
    var e =
      t && t.__esModule
        ? function () {
            return t.default;
          }
        : function () {
            return t;
          };
    return (r.d(e, { a: e }), e);
  }),
    (r.d = function (t, e) {
      for (var n in e)
        r.o(e, n) &&
          !r.o(t, n) &&
          Object.defineProperty(t, n, { enumerable: !0, get: e[n] });
    }),
    (r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (function () {
      "use strict";
      function t(t, e, r, n, o, i, a) {
        try {
          var c = t[i](a),
            u = c.value;
        } catch (t) {
          return void r(t);
        }
        c.done ? e(u) : Promise.resolve(u).then(n, o);
      }
      var e = r(756),
        n = r.n(e);
      function o() {
        var e;
        return (
          (e = n().mark(function t() {
            var e, r, o, i, a, c, u, s, l, f;
            return n().wrap(
              function (t) {
                for (;;)
                  switch ((t.prev = t.next)) {
                    case 0:
                      return (
                        (e = document.getElementById("kl_subscribe_list")),
                        (r = document.querySelector(".success")),
                        (o = document.querySelector(".error")),
                        (i = e.querySelector('input[name="kl_list"]').value),
                        (a = e.querySelector('input[name="user_email"]').value),
                        (c = e.querySelector('input[name="user_zip"]').value),
                        (u = document.querySelector(".nl-block")),
                        (s = {
                          method: "POST",
                          headers: {
                            revision: "2024-07-15",
                            "content-type": "application/json",
                          },
                          body: JSON.stringify({
                            data: {
                              type: "subscription",
                              attributes: {
                                profile: {
                                  data: {
                                    type: "profile",
                                    attributes: {
                                      location: { zip: c },
                                      email: a,
                                    },
                                  },
                                },
                                custom_source:
                                  "Account dashboard subscribe button",
                              },
                              relationships: {
                                list: { data: { type: "list", id: i } },
                              },
                            },
                          }),
                        }),
                        (t.prev = 9),
                        (t.next = 12),
                        fetch(
                          "https://a.klaviyo.com/client/subscriptions/?company_id=".concat(
                            "UYwKnY",
                          ),
                          s,
                        )
                      );
                    case 12:
                      if ((l = t.sent).ok) {
                        t.next = 18;
                        break;
                      }
                      return ((t.next = 16), l.json());
                    case 16:
                      throw (
                        (l = t.sent),
                        new Error(
                          (null === (f = l.errors) ||
                          void 0 === f ||
                          null === (f = f[0]) ||
                          void 0 === f
                            ? void 0
                            : f.detail) || "Unknown error occurred",
                        )
                      );
                    case 18:
                      (u.classList.add("hidden"),
                        r.classList.remove("hidden"),
                        o.classList.add("hidden"),
                        console.log("Form submitted"),
                        (t.next = 30));
                      break;
                    case 24:
                      ((t.prev = 24),
                        (t.t0 = t.catch(9)),
                        r.classList.add("hidden"),
                        o.classList.remove("hidden"),
                        (o.textContent = "Failed to subscribe: ".concat(
                          t.t0.message,
                        )),
                        console.log(
                          'Failed to subscribe. Reason: "'.concat(
                            t.t0.message,
                            '"',
                          ),
                        ));
                    case 30:
                    case "end":
                      return t.stop();
                  }
              },
              t,
              null,
              [[9, 24]],
            );
          })),
          (o = function () {
            var r = this,
              n = arguments;
            return new Promise(function (o, i) {
              var a = e.apply(r, n);
              function c(e) {
                t(a, o, i, c, u, "next", e);
              }
              function u(e) {
                t(a, o, i, c, u, "throw", e);
              }
              c(void 0);
            });
          }),
          o.apply(this, arguments)
        );
      }
      (document.addEventListener("DOMContentLoaded", function () {
        console.log("DOM fully loaded and parsed");
        var t = new URLSearchParams(window.location.search).get("view"),
          e = document.querySelector("#account .customer-dashboard-container"),
          r = document.querySelector("#account .customer-orders-container"),
          n = document.querySelector("#account .customer-contact-preferences"),
          o = document.querySelector(
            "#account .section.pbj-rich-text > .isolate",
          ),
          i = document.querySelector(
            "#account main .section:last-of-type > .app-section",
          ),
          a = document.querySelector("#account .pbj-link-list");
        t
          ? (console.log(t),
            document.body.setAttribute("view", t),
            r && "orders" === t && (r.style.display = "block"),
            n && "contact-preferences" === t && (n.style.display = "block"),
            o &&
              i &&
              "club" === t &&
              ((o.style.display = "block"),
              (i.style.display = "block"),
              i.prepend(o),
              a.insertAdjacentElement("afterend", i)))
          : e && (e.style.display = "block");
      }),
        (window.klaviyoSubscribeToList = function () {
          return o.apply(this, arguments);
        }));
    })());
})();
